// Punto Estilo — Auto-selección de variantes + Trust Badges
(function () {
  'use strict';

  // ── AUTO-SELECCIÓN DE VARIANTES ────────────────────────────────────────────
  function autoSelectVariants() {
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    if (productForms.length === 0) return;

    productForms.forEach(function (form) {
      const variantContainers = form.querySelectorAll('variant-selects, variant-radios, .product-form__input');

      function processFieldset(fieldset) {
        var inputs = fieldset.querySelectorAll('input[type="radio"]:not([disabled])');
        if (inputs.length === 0) return;
        var hasChecked = Array.from(inputs).some(function (i) { return i.checked; });
        if (!hasChecked) {
          inputs[0].checked = true;
          inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
          inputs[0].dispatchEvent(new Event('input',  { bubbles: true }));
        }
      }

      function processSelect(select) {
        if (select.value) return;
        var firstEnabled = Array.from(select.options).find(function (o) { return !o.disabled && o.value; });
        if (firstEnabled) {
          select.value = firstEnabled.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (variantContainers.length > 0) {
        variantContainers.forEach(function (container) {
          container.querySelectorAll('fieldset').forEach(processFieldset);
          container.querySelectorAll('select').forEach(processSelect);
        });
      } else {
        form.querySelectorAll('fieldset').forEach(processFieldset);
        form.querySelectorAll('select').forEach(processSelect);
      }
    });
  }

  // ── TRUST BADGES ───────────────────────────────────────────────────────────
  function injectTrustBadges() {
    if (document.querySelector('.pe-trust-badges')) return;

    // Buscar el contenedor de botones del formulario de producto
    const targets = [
      '.product-form__buttons',
      '.product-form__submit-wrap',
      'form[action*="/cart/add"] .product-form__error-message-wrapper',
      'form[action*="/cart/add"]'
    ];

    let insertAfter = null;
    for (let i = 0; i < targets.length; i++) {
      const el = document.querySelector(targets[i]);
      if (el) { insertAfter = el; break; }
    }

    if (!insertAfter) return;

    const badges = `
<div class="pe-trust-badges" role="list" aria-label="Garantías de compra">
  <div class="pe-trust-badge" role="listitem">
    <span class="pe-trust-badge__icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
    </span>
    <span class="pe-trust-badge__text">Pago Seguro</span>
  </div>
  <div class="pe-trust-badge" role="listitem">
    <span class="pe-trust-badge__icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
    </span>
    <span class="pe-trust-badge__text">Envío Gratis Rápido</span>
  </div>
  <div class="pe-trust-badge" role="listitem">
    <span class="pe-trust-badge__icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
    </span>
    <span class="pe-trust-badge__text">Devolución 30 Días</span>
  </div>
</div>`;

    insertAfter.insertAdjacentHTML('afterend', badges);
  }

  // ── INIT ───────────────────────────────────────────────────────────────────
  function init() {
    setTimeout(autoSelectVariants, 400);
    setTimeout(injectTrustBadges, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(autoSelectVariants, 200);
    setTimeout(injectTrustBadges, 300);
  });
  document.addEventListener('page:load', init);
})();
